import Vue from "vue";
import Vuex from "vuex";
import attributes from "../../models/atributos/attributes";
import service from "../../services/atributos/attributes";
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    service: new service(),
    attributes: [],
    newAttribute: [],
    edit: [],
    modeForm: "",
    openform: false,
    itemDelete: [],
    openDelete: false,
  },

  mutations: {
    setAttributes(state, data) {
      state.attributes = data;
    },
    setNewAttribute(state, data) {
      state.newAttribute = data;
    },
    setEdit(state, data) {
      state.edit = data;
    },
    setModeForm(state, data) {
      state.modeForm = data;
    },
    setOpenform(state, data) {
      state.openform = data;
    },
    setOpenDelete(state, data) {
      state.openDelete = data;
    },
    setItemDelete(state, data) {
      state.itemDelete = data;
    },
  },
  actions: {
    async getAttributes(state) {
      return new Promise(async (resolve, reject) => {
        try {
          let item = await state.state.service.getAttributes();
          state.commit("setAttributes", item);
          resolve(true);
        } catch (error) {
          reject(error);
        }
      });
    },

    async addAttributes(state) {
      try {
        const response = await state.state.service.addAttributes(
          state.state.newAttribute
        );
        const newItem = attributes.fromJson(response.data);
        const updatedAttributes = [newItem, ...state.state.attributes];
        state.commit("setAttributes", updatedAttributes);
        return true;
      } catch (error) {
        throw error;
      }
    },

    async deleteAttribute(state) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service
            .deleteAttribute(state.state.itemDelete.atribId)
            .then(() => {
              let options = state.state.attributes;
              options = options.filter((option) => {
                return option.atribId != state.state.itemDelete.atribId;
              });
              state.commit("setAttributes", options);
              resolve(true);
            });
        } catch (error) {
          reject(error);
        }
      });
    },

    async editAttribute(state) {
      return new Promise(async (resolve, reject) => {
        try {
          const item = state.state.edit;
          await state.state.service.editAttribute(item).then(() => {
            let options = state.state.attributes;
            if (options) {
              options = options.map((option) => {
                if (option.atribId !== item.atribId) {
                  return option;
                } else {
                  let updatedOption = {
                    ...option,
                  };
                  if (
                    item.hasOwnProperty("name") &&
                    option.name !== item.name
                  ) {
                    updatedOption.name = item.name;
                  }
                  if (
                    item.hasOwnProperty("description") &&
                    option.description !== item.description
                  ) {
                    updatedOption.description = item.description;
                  }
                  if (
                    item.hasOwnProperty("type") &&
                    option.type !== item.type
                  ) {
                    updatedOption.type = item.type;
                  }
                  if (
                    item.hasOwnProperty("values") &&
                    option.values !== item.values
                  ) {
                    updatedOption.values = item.values;
                  }

                  return updatedOption;
                }
              });
            }
            state.commit("setAttributes", options);
            resolve(true);
          });
        } catch (error) {
          reject(error);
        }
      });
    },
  },
});
